import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './sentry';
import { loadEnv } from './env';
import { App } from './app';

const { sentryDsn } = loadEnv();
if (sentryDsn) initSentry(sentryDsn);

if (import.meta.env.DEV) {
  import('eruda').then(({ default: eruda }) => eruda.init());
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('[mrrmlab/web] #root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
